import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-br from-white via-blue-50 to-white overflow-hidden">
      {/* Animated Circle Backgrounds */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-blue-100 rounded-full opacity-40 animate-pulse"></div>
        <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-blue-200 rounded-full opacity-30 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-50 rounded-full opacity-20 animate-pulse delay-2000"></div>
        <div className="absolute top-40 right-20 w-40 h-40 bg-blue-100 rounded-full opacity-30 animate-float-slow"></div>
        <div className="absolute bottom-40 left-20 w-32 h-32 bg-blue-200 rounded-full opacity-25 animate-float"></div>
        
        {/* Small floating circles */}
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-blue-300 rounded-full opacity-30 animate-float-particle"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-16 z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          
          {/* Logo and Description Section */}
          <div className="md:col-span-5">
            <NavLink to="/" className="inline-block group">
              <div className="flex items-center gap-2">
             
                <span className="text-xl font-bold text-blue-600 group-hover:text-blue-700 transition-colors duration-300">
                  HKMS
                </span>
              </div>
            </NavLink>
            <p className="mt-6 text-sm leading-relaxed text-gray-600">
              Professional House Keeping Management System designed to streamline 
              housekeeping operations, manage staff assignments, track room status, 
              and ensure quality service delivery across all your properties.
            </p>
          </div>

          {/* Company Links */}
          <div className="md:col-span-2">
            <h6 className="text-sm font-semibold text-gray-800 mb-4">Company</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <NavLink 
                  to="/aboutus" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-600'}`
                  }
                >
                  Home  
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-600'}`
                  }
                >
                  Feature
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/" 
                  className={({ isActive }) => 
                    `transition-colors duration-300 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-600'}`
                  }
                >
                  Contact
                </NavLink>
              </li>
              <li>
              
              </li>
            </ul>
          </div>

         

          {/* Social Media Section */}
          <div className="md:col-span-3">
            <div>
              <h6 className="text-sm font-semibold text-gray-800 mb-3">Follow Us</h6>
              <div className="flex gap-4">
                <a 
                  href="https://www.instagram.com/ai.zops/"
                  target="_blank" 
                  rel="noreferrer" 
                  className="w-9 h-9 bg-blue-50 rounded-full flex items-center justify-center text-gray-500 hover:text-white hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                  aria-label="Instagram"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z" />
                  </svg>
                </a>
                <a 
                  href="https://www.facebook.com/ai.zops/"
                  target="_blank" 
                  rel="noreferrer" 
                  className="w-9 h-9 bg-blue-50 rounded-full flex items-center justify-center text-gray-500 hover:text-white hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                  aria-label="Facebook"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a 
                  href="https://x.com/ai_zops/" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="w-9 h-9 bg-blue-50 rounded-full flex items-center justify-center text-gray-500 hover:text-white hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                  aria-label="Twitter"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
               
                <a 
                  href="https://www.youtube.com/@AIZOPS/" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="w-9 h-9 bg-blue-50 rounded-full flex items-center justify-center text-gray-500 hover:text-white hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                  aria-label="YouTube"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div className="mt-6">
              <h6 className="text-sm font-semibold text-gray-800 mb-3">Contact Info</h6>
              <div className="space-y-2 text-sm text-gray-500">
                <p className="flex items-center gap-2 hover:text-blue-600 transition-colors duration-300">
                  <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span>support@aizops.com</span>
                </p>
                <p className="flex items-center gap-2 hover:text-blue-600 transition-colors duration-300">
                  <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <span>     +91 9046373358,
</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-blue-100 mt-12 pt-6 text-center text-sm text-gray-400">
          <p>© 2026 House Keeping Management System. All rights reserved.</p>
       
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(-15px) translateX(10px); }
        }
        @keyframes float-slow {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(-10px) translateX(-10px); }
        }
        @keyframes float-particle {
          0%, 100% { transform: translateY(0px) translateX(0px); opacity: 0; }
          20% { opacity: 0.5; }
          80% { opacity: 0.3; }
          100% { transform: translateY(-80px) translateX(40px); opacity: 0; }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        .animate-float-slow {
          animation: float-slow 6s ease-in-out infinite;
        }
        .animate-float-particle {
          animation: float-particle 4s ease-in-out infinite;
        }
      `}</style>
    </footer>
  );
}